enum FieldDictionaryScreenSize {
    Large = 1,
    Medium = 2,
    Small = 3,
}

export default FieldDictionaryScreenSize;
